/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { RemoveFromWatchlistResponse, RemoveFromWatchlistVars } from '../openapi-types.gen.js';

export type { RemoveFromWatchlistResponse, RemoveFromWatchlistVars } from '../openapi-types.gen.js';

export const useRemoveFromWatchlist = createMutationHook<RemoveFromWatchlistVars, RemoveFromWatchlistResponse, unknown>({
  specName: 'useRemoveFromWatchlist',
  path: '/v1/watchlist/{kind}/{pubkey}',
  method: 'DELETE',
  resolveUrl: (vars: RemoveFromWatchlistVars) => `/v1/watchlist/${vars.kind}/${vars.pubkey}`,
  
  parseResponse: (raw: unknown): RemoveFromWatchlistResponse => raw as RemoveFromWatchlistResponse,
  optimistic: [{
    queryKey: ['watchlist', 'detail'],
    apply: (prev: any, vars: RemoveFromWatchlistVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  viewerRelationship: {"kind":"watchlist","targetArg":"pubkey","active":false,"indexArg":"kind"} as const,
  
});
